import * as types from "../mutation-types";

export const state = {
  isActive: false,
  isMinimized: false
};

export const mutations = {
  [types.CHAT_SET_ACTIVE](state, value) {
    state.isActive = value;
  },

  [types.CHAT_SET_MINIMIZED](state, value) {
    state.isMinimized = value;
  }
};

export const actions = {
  setChatActive({ commit }, value) {
    commit(types.CHAT_SET_ACTIVE, value);
  },

  setChatMinimized({ commit }, value) {
    commit(types.CHAT_SET_MINIMIZED, value);
  }
};

export const getters = {
  isChatActive: state => state.isActive,
  isChatMinimized: state => state.isMinimized
};

export default {
  state,
  mutations,
  actions,
  getters
}; 